import { Field } from "formik";
import { useState } from "react";
import { useUniqueId } from "shared/uniqueId/useUniqueId";
import { useSurveyForm } from "../helpers/useSurveyForm";
import { useRunOnMount } from "shared/useRunOnMount/useRunOnMount";
import { useToast } from "shared/toast/useToast";
import { SiteSurveyConfiguration } from "api/types/siteSurveyConfiguration";
import { Attributes } from "./Attributes";
import { Photos } from "../Photos";
import { Photo } from "api/types/photo";
import { Buttons } from "../Buttons";
import { getEmptyUnit } from "../helpers/getEmptyUnit";
import { getFormikNameForUnitProps } from "../helpers/getFormikNameForUnitProps";

export function AddEditUnit({
  unitId,
  config,
}: {
  unitId: number | null | undefined;
  config: SiteSurveyConfiguration;
}) {
  //Not Translated
  const { survey, setValues } = useSurveyForm();
  const [unitIndex, setUnitIndex] = useState<number | undefined>(undefined);
  const { error } = useToast();
  useRunOnMount(() => {
    if (unitId === null || unitId === undefined) {
      const emptyUnit = getEmptyUnit(survey);

      survey.units.push(emptyUnit);
      setUnitIndex(survey.units.length - 1);
    } else {
      const matchingIndex = survey.units.findIndex((u) => u.id === unitId);
      if (matchingIndex >= 0) {
        setUnitIndex(matchingIndex);
      } else {
        error("Invalid unit id, make sure you have the correct link");
      }
    }
  });

  function handleOnChange(photos: Photo[]) {
    currentUnit.photos = [...photos];
    setValues(survey);
  }

  function handleOnPhotoDelete(photo: Photo) {
    currentUnit.photos = currentUnit.photos.filter((p) => p !== photo);
    setValues(survey);
  }

  if (unitIndex === undefined) return null;

  const currentUnit = survey.units[unitIndex];
  return (
    <>
      <UnitSection unitIndex={unitIndex} />
      <Attributes config={config} unitIndex={unitIndex} />

      <div className="my-2">Unit Photos</div>
      <Photos
        photoTypes={config.unitConfiguration.photoTypes}
        photos={currentUnit.photos}
        onChange={handleOnChange}
        onDelete={handleOnPhotoDelete}
      />
      <Buttons />
    </>
  );
}

function UnitSection({ unitIndex }: { unitIndex: number }) {
  const { uid } = useUniqueId("unit");
  return (
    <>
      <div className="mt-3">
        <label htmlFor={uid("rtu")} className="form-label">
          RTU
        </label>
        <Field
          className="form-control"
          id={uid("rtu")}
          name={getFormikNameForUnitProps(unitIndex, "rtu")}
        />
      </div>
      <div className="mt-3">
        <label htmlFor={uid("model")} className="form-label">
          Model
        </label>
        <Field
          className="form-control"
          id={uid("model")}
          name={getFormikNameForUnitProps(unitIndex, "modelNumber")}
        />
      </div>
      <div className="mt-3">
        <label htmlFor={uid("serialNumber")} className="form-label">
          Serial
        </label>
        <Field
          className="form-control"
          id={uid("serialNumber")}
          name={getFormikNameForUnitProps(unitIndex, "serialNumber")}
        />
      </div>
    </>
  );
}
